import { toast } from "react-toastify";

export function notify(state, refresh = false) {
  const message = state?.meta?.message || "Something went wrong";
  const code = state?.meta?.code;

  const options = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  };

  if (code === 200) {
    toast.success(message, options);
    if (refresh) {
      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
  } else if (code === 1000) {
    toast.info(message, options);
  } else if (code === 422) {
    toast.error(message, options);
  } else {
    if (code && code !== 0) toast.error(message, options);
  }
}
